import * as S from './Rating.sc';

type RatingProp = {
  score: string;
  section: Section;
  summary: string;
  title: 'Build' | 'Display' | 'Play' | 'Value';
};

const Rating = ({ score, section, summary, title }: RatingProp) => {
  if (!score || score === '0') {
    return null;
  }
  return (
    <S.Rating section={section.toLowerCase()}>
      <S.Title>{title}</S.Title>
      <S.Score score={score} section={section.toLowerCase()}>
        <S.Value>{score}</S.Value>
      </S.Score>
      <S.Summary>{summary}</S.Summary>
    </S.Rating>
  );
};

export default Rating;
